module.exports = __webpack_public_path__ + "img/creditplus.bdc81a75.svg";